<template>
  <div class="radios-list">
    <div
      v-for="(choice, i) in localField.choices"
      :key="i"
      class="radios-list__item"
    >
      <input
        :id="`field-radio-${localField.id || localField.name}-${choice[0]}`"
        type="radio"
        :value="choice[0]"
        :name="localField.name"
        class="radio"
        :required="localField.required"
        :checked="choice[0] === value"
        @input="$emit('input', choice[0])"
      />
      <label
        :for="`field-radio-${localField.id || localField.name}-${choice[0]}`"
        class="label"
        :class="{ active: choice[0] === value }"
        >{{ choice[1] }}</label
      >
    </div>
  </div>
</template>

<script>
import { computed, inject } from 'vue';
import { formGroupKey } from '@/components/forms/FormGroup.vue';

export default {
  props: {
    value: {
      required: false,
      type: [Boolean, String],
      default: null,
    },
    field: {
      type: Object,
      default: null,
    },
  },

  setup(props) {
    const group = inject(formGroupKey, { field: null, id: null });
    const localField = computed(() => {
      return props.field || group.field;
    });

    return {
      localField,
    };
  },
};
</script>

<style lang="scss" scoped>
.radios-list {
  overflow: hidden;

  border-radius: $border-radius-default;
}

.radios-list__item {
  position: relative;

  + .radios-list__item {
    margin-top: 2px;
  }
}

.label {
  display: block;
  padding: 10px $spacing-unit-small 10px 44px;

  background-color: lighten($alt-color-lighter, 2.5%);

  &.active,
  &:hover {
    background-color: white;
  }

  &::before {
    content: '';
    display: block;
    width: 18px;
    height: 18px;

    left: $spacing-unit-small;
    top: 14px;

    position: absolute;

    border-radius: 50%;
    border: 1px solid $alt-color-light;
    transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }

  &.active::before {
    transform: scale(1.333333);

    background: $brand-color
      url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22%23fff%22%3E%3Cpath%20d%3D%22M3.05%2C12.53a2%2C2%2C0%2C0%2C1%2C3.41-1.41L9.05%2C13.7l8.59-8.58a2%2C2%2C0%2C0%2C1%2C2.82%2C2.82L9.05%2C19.36%2C3.64%2C13.94A2%2C2%2C0%2C0%2C1%2C3.05%2C12.53Z%22%2F%3E%3C%2Fsvg%3E')
      no-repeat center;
    background-size: 10px 10px;
    border-color: transparent;
  }
}

.radio {
  opacity: 0;

  position: absolute;
  left: 0;
  top: 0;

  &:focus {
    + .label {
      background-color: white;

      &::before {
        box-shadow: 0 0 0 3px $brand-alt-color;
      }
    }
  }
}
</style>
